import { render, staticRenderFns } from "./ReferralCloseModal.vue?vue&type=template&id=3d24b27e&"
import script from "./ReferralCloseModal.vue?vue&type=script&lang=ts&"
export * from "./ReferralCloseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports